import Select from "ol/interaction/Select";
import { click, pointerMove } from "ol/events/condition";
import {
  getEmissionRegulationStyleClick,
  getEmissionRegulationStyleHover,
} from "../style/lez";

export function getEmissionRegulationInteractions(layer, control) {
  const clickSelect = new Select({
    layers: [layer],
    condition: click,
    style: function (feature) {
      return getEmissionRegulationStyleClick(feature);
    },
  });
  clickSelect.on("select", function (e) {
    if (e.target.getFeatures().getLength() > 0) {
      control.set(
        "selectedFeatures",
        Array.from(e.target.getFeatures().getArray()),
      ); // create new array so that the event gets triggered
    } else {
      control.set("selectedFeatures", undefined);
    }
  });
  return [
    clickSelect,
    new Select({
      layers: [layer],
      condition: pointerMove,
      style: function (feature) {
        return getEmissionRegulationStyleHover(feature);
      },
    }),
  ];
}
